export enum InboundDeliveryNoteKind {
  WARENEINGANG = 'WARENEINGANG',
  RUECKNAHME_MIETARTIKEL = 'RUECKNAHME_MIETARTIKEL',
}
